<template>
<div>
    <b-modal id="matterSecurityDepositFormModal" ref="matterSecurityDepositFormModal" centered size="lg" no-close-on-backdrop :title=" $t('matterSecurityDeposit.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <b-row>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterSecurityDeposit.deposit_type') }}</label>
                    <b-form-group>
                        <b-form-select size="sm" v-model="lawSecurityDepositTypeSelect" value-field="id" text-field="name" :options="lawSecurityDepositTypeOption" />
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterSecurityDeposit.price') }}</label>
                    <b-form-group>
                        <cleave v-model="price" class="cleaveStyle form-control" :options="cleaveOptions"></cleave>
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterSecurityDeposit.currency') }}</label>
                    <b-form-group>
                        <b-form-select size="sm" v-model="currencySelect" value-field="id" text-field="code" :options="currencyOption" />
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterSecurityDeposit.payment_deadline') }}</label>
                    <b-form-group>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" placeholder="" size="sm" v-model="paymentDeadline" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterSecurityDeposit.deposit_method') }}</label>
                    <b-form-group>
                        <b-form-select size="sm" v-model="lawSecurityDepositMethodSelect" value-field="id" text-field="name" :options="lawSecurityDepositMethodOption" />
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterSecurityDeposit.deposit_date') }}</label>
                    <b-form-group>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" placeholder="" size="sm" v-model="securityDepositDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterSecurityDeposit.return_to_us_date') }}</label>
                    <b-form-group>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" placeholder="" size="sm" v-model="returnToUsDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterSecurityDeposit.client_refund_method') }}</label>
                    <b-form-group>
                        <b-form-select size="sm" v-model="lawSecurityDepositClientRefundMethodSelect" value-field="id" text-field="name" :options="lawSecurityDepositClientRefundMethodOption" />
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterSecurityDeposit.client_refund_date') }}</label>
                    <b-form-group>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" placeholder="" size="sm" v-model="securityDepositClientRefundDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            lawSecurityDepositTypeSelect: 0,
            lawSecurityDepositTypeOption: [],
            price: 0,
            currencySelect: 0,
            currencyOption: [],
            paymentDeadline: null,
            lawSecurityDepositMethodSelect: 0,
            lawSecurityDepositMethodOption: [],
            securityDepositDate: null,
            returnToUsDate: null,
            lawSecurityDepositClientRefundMethodSelect: 0,
            lawSecurityDepositClientRefundMethodOption: [],
            securityDepositClientRefundDate: null,
            cleaveOptions: {
                prefix: '',
                numeral: true,
                numeralPositiveOnly: true,
                noImmediatePrefix: true,
                rawValueTrimPrefix: true,
                numeralIntegerScale: 9,
                numeralDecimalScale: 2,
                delimiter: '.',
                numeralDecimalMark: ',',
            },
        }
    },
    methods: {
        showSecurityDeposit(id, lawMatterId) {
            this.$refs['matterSecurityDepositFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawMatterSecurityDeposit'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.lawSecurityDepositTypeOption = response.data.lawSecurityDepositTypeList
                    this.lawSecurityDepositTypeOption.splice(0, 0, this.$nullSelected())
                    this.lawSecurityDepositTypeSelect = response.data.lawMatterSecurityDeposit.lawSecurityDepositTypeId

                    this.price = response.data.lawMatterSecurityDeposit.price

                    this.currencyOption = response.data.currencyList
                    this.currencyOption.splice(0, 0, this.$nullSelected('code'))
                    this.currencySelect = response.data.lawMatterSecurityDeposit.currencyId

                    this.paymentDeadline = response.data.lawMatterSecurityDeposit.paymentDeadline

                    this.lawSecurityDepositMethodOption = response.data.lawSecurityDepositMethodList
                    this.lawSecurityDepositMethodOption.splice(0, 0, this.$nullSelected())
                    this.lawSecurityDepositMethodSelect = response.data.lawMatterSecurityDeposit.lawSecurityDepositMethodId

                    this.securityDepositDate = response.data.lawMatterSecurityDeposit.securityDepositDate
                    this.returnToUsDate = response.data.lawMatterSecurityDeposit.returnToUsDate

                    this.lawSecurityDepositClientRefundMethodOption = response.data.lawSecurityDepositClientRefundMethodList
                    this.lawSecurityDepositClientRefundMethodOption.splice(0, 0, this.$nullSelected())
                    this.lawSecurityDepositClientRefundMethodSelect = response.data.lawMatterSecurityDeposit.lawSecurityDepositClientRefundMethodId

                    this.securityDepositClientRefundDate = response.data.lawMatterSecurityDeposit.securityDepositClientRefundDate
                } else {
                    this.$bvModal.hide('matterSecurityDepositFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async addOrUpdate() {
            const data = {
                id: this.id,
                lawMatterId: this.lawMatterId,
                lawSecurityDepositTypeId: this.lawSecurityDepositTypeSelect,
                price: this.price,
                currencyId: this.currencySelect,
                paymentDeadline: this.paymentDeadline,
                lawSecurityDepositMethodId: this.lawSecurityDepositMethodSelect,
                securityDepositDate: this.securityDepositDate,
                returnToUsDate: this.returnToUsDate,
                lawSecurityDepositClientRefundMethodId: this.lawSecurityDepositClientRefundMethodSelect,
                securityDepositClientRefundDate: this.securityDepositClientRefundDate,
            }
            const controller = {
                name: 'LawMatterSecurityDeposit'
            }
            const payload = {
                data: data,
                controller: controller
            }
            var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if (!this.id) {
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(17, this.id, this.lawMatterId, this.employeeId)
                    this.getMatterTypeHistoryList()
                }
                this.$bvModal.hide('matterSecurityDepositFormModal')
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
